import { Injectable } from '@angular/core';
import { AttendanceSummaryModel } from '../models/attendance-model';
import { HttpClient } from '@angular/common/http';
import { ReplaySubject, Observable } from 'rxjs';
import { AppSettings } from '../../../../utils/app-settings';

@Injectable()
export class AttendanceService {

  constructor(private http: HttpClient) { }
  private http_fetched: boolean = false;
  private _attendance: ReplaySubject<AttendanceSummaryModel> = new ReplaySubject<AttendanceSummaryModel>(1);

  getAttendanceForAcademicYear(): Observable<AttendanceSummaryModel> {
    if (!this.http_fetched) {
      this.http_fetched = true;
      this.http.get<AttendanceSummaryModel>(AppSettings.apiUrl + "attendance")
        .subscribe(res => {
          this._attendance.next(res);
        }, error => {
          this.http_fetched = false;
          console.error(error);
        });
    }
    return this._attendance.asObservable();
  }
}
